import styled from "styled-components";

export const TileWrapper = styled.div`
  background: ${({ theme }) => theme.elementColor.tileBackground};
  box-shadow: 0px -2px 50px rgba(9, 10, 51, 0.02),
    0px 16px 58px rgba(9, 10, 51, 0.03);
  border-radius: 4px;
`;
